// src/components/Card3D.jsx
import React from 'react'

const Card3D = ({ 
  children, 
  className = '', 
  onClick,
  as: Component = 'div',
  ...props 
}) => {
  return (
    <Component
      {...props}
      onClick={onClick}
      className={`
        bg-white rounded-xl shadow-lg p-6
        transition-all duration-300 ease-in-out
        hover:-translate-y-2 hover:scale-105 hover:shadow-2xl
        focus:outline-none focus:ring-4 focus:ring-ofanda-indigo/40
        cursor-pointer
        ${className}
      `}
    >
      {children}
    </Component>
  )
}

export default Card3D